import React from "react";
import { Link } from "react-router-dom";

/**
 * Componente para mostrar el footer del tercer nivel de los servicios, estas se cargan  de forma aleatoría
 * a través de iteraciones tomando la información desde el archivo .src/data/data.json -> "Services"
 *
 * @component
 * @example
 * 
 * "Services": [
    {
      "id": 0,
      "img": "/img/services/BuyerPersona.webp",
      "img_mob": "/img/services/BuyerPersona_mob.webp",
      "imgFooter": "/img/services/BuyerPersona.webp",
      "name": "Buyer Persona",
      "text": "Construimos perfiles de audiencia detallados para impulsar estrategias de marketing personalizadas.",
      "url": "/servicios/buyerPersona"
    }
  ]
 * 
 */

export const ServicesFooter = (props) => {
  return (
    <div id="service-footer" className="text-center">
        <div className="row">
            <div className="col-md-12">
                <div className="col-md-12 d-flex our-services">
                    <span>Nuestro Servicios</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Link to={'/services'} className="btn btn-custom">
                        <span>Ver todo</span>&nbsp;&nbsp;
                        <img alt="ram" src="/img/Arrow.png"></img>
                    </Link>
                </div>
            </div>
            {props.data ? props.data.filter(service => service.id !== props.id).sort(() => 0.5 - Math.random()).slice(0,3).map((d, i) => (
                <div key={`dv1${i}`} className="col-md-4 col-sm-6 text-center">
                    <div key={`dv2${i}`} className="imgContainer">
                            <Link key={`lnk1${i}`} to={d.url}>
                                <img className="img-responsive" key={`img${i}`} alt={d.name} src={d.imgFooter} />
                            </Link>
                            <div key={`dv3${i}`} className="col-md-12 titleContainer">
                                <div key={`dv4${i}`} className="col-md-10 col-sm-6 col-xs-6 titleContainer">
                                    <Link key={`lnk2${i}`} to={d.url}>
                                        <p key={`p${i}`}>{d.name}</p>
                                    </Link>
                                </div>
                                <div key={`dv5${i}`} className="col-md-2 col-sm-6 col-xs-6 dvTitle">
                                    <Link key={`lnk3${i}`} to={d.url}>
                                        <img alt="ram" src="/img/Arrow.png" className="imgTitle"></img>
                                    </Link>
                                </div>
                            </div>
                    </div>
                </div>
                ))
                : "loading"}
            
        </div>
    </div>
  );
};
